<template>
    <div class="row p-1 table-row bg-white">
        <div class="col-3 d-flex flex-column justify-content-center">
            <span class="d-flex align-content-center">
                <small class="d-flex align-content-center font-italic mr-2">From: </small>
                <v-date-picker
                    id="date_start"
                    popover-align="left"
                    class="picker-container"
                    v-model="newData.date_start"
                ></v-date-picker>
            </span>
            <span class="d-flex align-content-center">
                <small class="d-flex align-content-center font-italic mr-2">to: </small>
                <v-date-picker
                    id="date_end"
                    class="picker-container"
                    popover-align="left"
                    v-model="newData.date_end"
                ></v-date-picker>
            </span>
        </div>
        <div class="col-4 d-flex flex-column justify-content-center">
            <select class="form-control form-control-sm font-italic" v-model="newData.specialist">
                <option v-for="s in specialists" :value="s.id">{{ s.name }}</option>
            </select>
            <small class="link cursor-pointer">> Add a new specialist information</small>
        </div>
        <div class="col-4 d-flex flex-column justify-content-center">
            <textarea
                name="service"
                id="service"
                rows="1"
                v-model="newData.service"
                class="form-control"
            ></textarea>
        </div>
        <div class="col-1 px-0">
            <div class="d-flex w-100 h-100 justify-content-between">
                <div
                    @click="saveEntry()"
                    v-if="!entry"
                    class="h-100 d-flex flex-column justify-content-center align-items-center cursor-pointer"
                >
                    <i class="fa fa-times-circle-o rot-45 text-primary"></i>
                    <small
                        ><em style="white-space: nowrap;" class="text-primary">Add Data</em></small
                    >
                </div>
                <div
                    @click="saveEntry()"
                    v-if="entry"
                    class="h-100 d-flex flex-column justify-content-center align-items-center cursor-pointer"
                >
                    <i class="fa fa-save text-primary"></i>
                    <small><em style="white-space: nowrap;" class="text-primary">Save</em></small>
                </div>
                <div
                    @click="cancelEntry()"
                    v-if="entry"
                    class="ml-1 h-100 d-flex flex-column justify-content-center align-items-center cursor-pointer"
                >
                    <i class="fa fa-times text-primary"></i>
                    <small><em style="white-space: nowrap;" class="text-primary">Cancel</em></small>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { fixDatePickers } from "../../plugins/fixDatePickers";

export default {
    name: "TimelineNewEntry",
    props: ["entry", "specialists"],
    mixins: [fixDatePickers],
    data() {
        return {
            newData: {},
        };
    },
    watch: {
        entry: {
            handler: "populateData",
            immediate: true,
        },
    },
    methods: {
        populateData() {
            if (this.entry) {
                this.newData = this.entry;
                this.newData.date_start = new Date(this.newData.date_start);
                this.newData.date_end = new Date(this.newData.date_end);
            }
        },
        cancelEntry() {
            this.$emit("edit-done");
        },
        saveEntry() {
            this.$emit("edit-done", this.newData); //Dummy edit
            // TODO: add endpoint
            let endpoint = "";
            if (this.entry) {
                axios
                    .patch(`${endpoint}${this.newData.id}`, this.newData)
                    .then(r => {
                        this.newData = {};
                        this.$emit("edit-done");
                        this.getData();
                    })
                    .catch(e => {
                        console.error(e);
                    });
            } else {
                axios
                    .post(`${endpoint}`, this.newData)
                    .then(r => {
                        this.newData = {};
                        this.$emit("edit-done");
                        this.getData();
                    })
                    .catch(e => {
                        console.error(e);
                    });
            }
        },
    },
};
</script>

<style scoped lang="scss">
.table-row:not(:last-child) {
    background-color: #ffffff;
    border: solid 1px #bfbfbf;
    border-bottom: none;
}
</style>
